import { Box, Typography } from '@mui/material';
import { Dialog } from 'components/commons';
import ja from 'utils/ja';

interface DialogSettingDBProps {
  open: boolean;
  onClose: () => void;
  handleConfirm: () => void;
}

const DialogSettingDB = ({
  open,
  onClose,
  handleConfirm,
}: DialogSettingDBProps) => {
  return (
    <Dialog
      open={open}
      handleClose={onClose}
      title={ja.side_bar.setting_db.title}
      handleConfirm={handleConfirm}
    >
      <Box
        sx={{
          width: { xs: '80vw', sm: '638px' },
          padding: '10px',
        }}
      >
        <Typography
          sx={{
            fontSize: '20px !important',
            fontWeight: '400',
            textAlign: 'center',
          }}
        >
          {ja.side_bar.setting_db.placeholder}
        </Typography>
      </Box>
    </Dialog>
  );
};
export default DialogSettingDB;
